let settings = {

    ws_url: "",

	routes: {
		login: "/pages/login",
		dashboard: "/",
		pedidos: "/pedidos/pedido",		
		documentos: "/documentos/documento",
	},

	usuarioAutenticado: {
		"EMPRESA": 0,
		"CLIENTE": 0
	},

	versao: "0.0.0",

	axios: {}
};

export default settings;